import React from "react";
import Buttons from "../../../components/ui/button/Buttons";
import FileUpload from "../../../components/ui/inputs/fileUpload/FileUpload";

const RequirementCard = ({
    item,
    reqId,
    isLocked,
    reqData,
    statusValue,
    caseOfficerComments,
    peerReviewerComments,
    onFileUpload,
    onDownload,
    onDelete,
    onCaseOfcCommentChange,
    onClarificationSend,
    onReject,
    onApprove,
    clarificationLoading,
    rejectLoading,
    approveLoading,
    className = "",
    children,
    isReturnedApplication
}) => {

    return (
        <div className={`evaluation-table ${className}`}>
            <div className="table-header">
                <div>{item.requirementName}</div>
                <div>Documents to Upload</div>
                <div>Submission</div>
            </div>

            <div className="table-body">
                <div className="column evaluation-table-wrapper instruction-content">
                    <div dangerouslySetInnerHTML={{ __html: item?.requirementDescription || "" }} />
                </div>

                <div className="column evaluation-table-wrapper instruction-content">
                    <div dangerouslySetInnerHTML={{ __html: item?.requirementToBeSubmitted || "" }} />
                </div>

                <div className="column submission">
                    {isLocked && (
                        <span style={{ color: "#f52828", fontSize: "18px", display: "block", marginBottom: "6px" }}>
                            🔒 This requirement is locked.
                        </span>
                    )}
                    <FileUpload
                        name="uploadFile"
                        onChange={(e) => onFileUpload(e, reqId)}
                        isButtonVisible={true}
                        isDownloadButton={true}
                        acceptedFiles=".jpg,.jpeg,.png,.webp,.svg,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.json,.xml,.zip,.rar"
                        maxFileSizeInKB={5000}
                        buttonText="Upload"
                        isDisable={isLocked}
                    />

                    <div className="files">
                        {(reqData?.files || []).map((f) => (
                            <p key={f.id} className="file-item">
                                <span
                                    className="file-name"
                                    onClick={() => onDownload(f)}
                                    style={{ color: "#000", cursor: isLocked ? "not-allowed" : "pointer" }}
                                >
                                    {f.name}
                                </span>
                                <span
                                    className="delete-file"
                                    onClick={() => onDelete(reqId, f)}
                                    style={{ cursor: isLocked ? "not-allowed" : "pointer" }}
                                >
                                    Delete
                                </span>
                            </p>
                        ))}
                    </div>
                    <label>Comment</label>
                    <textarea
                        disabled
                        placeholder=""
                        value={reqData?.comment || ""}
                        style={isLocked ? { background: "#f5f5f5", cursor: "not-allowed" } : {}}
                    />
                </div>

                {children}
            </div>

            <div className="status-bar">
                <span>Status</span>
                <span>{statusValue || ""}</span>
                <span></span>
            </div>
            <div className="commant-box">
                <label>Case Officer Clarification Comments (External)</label>
                <textarea
                    placeholder="SGBC Comments"
                    value={caseOfficerComments || ""}
                    onChange={(e) => onCaseOfcCommentChange(reqId, e.target.value)}
                    disabled={isLocked}
                    style={isLocked ? { background: "#f5f5f5", cursor: "not-allowed" } : {}}
                />
            </div>
            <div className="commant-box pt-0">
                <label>Peer Reviewer/Final Approver Comments (Internal)</label>
                <textarea placeholder="SGBC Comments" disabled value={peerReviewerComments || ""} />
            </div>
            <div className="form-actions mb-3">
                <div>
                    <Buttons
                        buttonText="Send Clarification"
                        buttonTypeClassName="success-btn yellow"
                        onClick={() => onClarificationSend(reqId)}
                        isDisable={clarificationLoading || (!isReturnedApplication && ["Approved", "Rejected"].includes(statusValue)) || isLocked}
                        isLoading={clarificationLoading}
                    />
                </div>
                <div style={{ display: "flex" }}>
                    <Buttons
                        buttonTypeClassName="reject  btn  reject-btn"
                        buttonText="Reject"
                        isDisable={rejectLoading || ["Rejected"].includes(statusValue) || isLocked}
                        isLoading={rejectLoading}
                        onClick={() => onReject(reqId)}
                    />
                    <Buttons
                        buttonText="Approve"
                        buttonTypeClassName="success-btn"
                        isDisable={approveLoading || ["Approved"].includes(statusValue) || isLocked}
                        isLoading={approveLoading}
                        onClick={() => onApprove(reqId)}
                    />
                </div>
            </div>
        </div>
    );
};

export default RequirementCard;